<p>searchable-combo-box works!</p>
